export var isIos = function () { return typeof navigator !== 'undefined' && /(iPad|iPhone|iPod)/g.test(navigator.userAgent); };
export var isMac = function () { return typeof navigator !== 'undefined' && /Mac/g.test(navigator.platform); };
